import { formatCardNumber } from '@common/helpers/format';
import { useAppSelector } from '@common/hooks/store';
import { isDomainZone } from '@common/utils/lang';
import { selectUserCountryCode } from '@features/auth/slice/authSlice';
import { IUpdateMoneyGateOrderBankResponse } from '@features/deposit/screens/money-gate/api/moneyGate.type';
import CheckCircle from '@mui/icons-material/CheckCircle';
import ContentCopy from '@mui/icons-material/ContentCopy';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';
import classNames from 'classnames';
import copy from 'copy-to-clipboard';
import React, { FC, useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import './gates.style.scss';

interface IDepositOnlineSPBFastPaymentProps {
  gateData: IUpdateMoneyGateOrderBankResponse;
  isLoading: boolean;
}


const DepositOnlineMoneyGateRequisites:FC<IDepositOnlineSPBFastPaymentProps> = ({ gateData,isLoading }) => {
  const [ isCopy, setIsCopy ] = useState<boolean>(false);
  const navigate = useNavigate();
  const countryCode = useAppSelector(selectUserCountryCode)?.toLowerCase();

  const handleCancel = useCallback(() => {
    navigate('/deposit');
  }, [ navigate ]);

  const handleCopyAmount = useCallback((cardInfo:string | null) => {
    if (cardInfo) {
      const clean = cardInfo.replace(/\s+/g, '');
      const success = copy(clean, { format: 'text/plain' });
      if (success) {
        setIsCopy(true);
        setTimeout(() => setIsCopy(false), 1700);
      }
    }
  }, []);

  const hasCardInfo = !!gateData?.requisites?.cardInfo;
  const requisiteNumber = hasCardInfo ? formatCardNumber(gateData.requisites.cardInfo) : gateData.requisites.phone;
  const amount = countryCode === 'ru' ? gateData?.amount : gateData?.customerAmount
  return (
    <Box className={classNames(isDomainZone('boxbet') && 'boxbet', 'deposit-gate__transfer-container')}>

      <Box className="deposit-gate__transfer-title">
        <Typography variant="h4" component="h4">
          Совершите перевод {!hasCardInfo && 'строго на ВАСЛ'} на
          сумму {amount} {' '}
          {gateData?.currency}
        </Typography>
      </Box>

      <Card className="deposit-gate__card-preview">
        <CardContent className="deposit-gate__card-inner">
          <CardMedia
            component="div"
            className="deposit-gate__card-bg"
          />

          {countryCode !== 'ru' && (
            <Box className="deposit-gate__card-logo">
            <img
              src="https://acquire.vasl.tech/km-logo.png"
              alt="Корти Милли"
            />
          </Box>)}

          <Box>
            <Box className="deposit-gate__card-number">
              {requisiteNumber}
              <Box display="flex" alignItems="center">
                {isCopy ? (
                  <IconButton
                    className="deposit-gate__card-number--copy">
                    <CheckCircle fontSize="small"/>
                  </IconButton>
                ) : (
                  <IconButton
                    className="deposit-gate__card-number--copy"
                    onClick={() => handleCopyAmount(requisiteNumber)}>
                    <ContentCopy fontSize="small"/>
                  </IconButton>
                )}
              </Box>
            </Box>

          </Box>

          <Box className="deposit-gate__card-details">
            <Box className="deposit-gate__card-holder">
              <Typography component="span">Владелец</Typography>
              <Typography component="span">{gateData?.requisites?.cardholder }</Typography>
            </Box>
            <Box className="deposit-gate__card-expires">

            </Box>
          </Box>
        </CardContent>

        <CardContent className="deposit-gate__card-back">
          <Box className="deposit-gate__card-stripe" />
          <Box className="deposit-gate__card-signature">
            <Box className="deposit-gate__signature-line" />
            <Box className="deposit-gate__cvc">CVC</Box>
          </Box>
          <Box className="deposit-gate__card-secure">Защищено</Box>
        </CardContent>
      </Card>


      <Box className="deposit-gate__transfer-steps">
        <List>
          <ListItem>
            <strong>01</strong>
            <span>Скопируйте реквизиты</span>
          </ListItem>
          <ListItem>
            <strong>02</strong>
            <span>Сделайте перевод по реквизитам на {amount} {gateData?.currency}</span>
          </ListItem>
        </List>
      </Box>

      <Box className="deposit-gate__transfer-actions">
        <Box marginTop={3} display={'flex'} gap={3}>
          <Button sx={{ boxShadow: 'none' }} className="deposit-gate__transfer-confirm" color="warning" variant="contained" type="submit" fullWidth onClick={handleCancel}>
            <FormattedMessage id="CANCEL"/>
          </Button>
        </Box>
      </Box>

    </Box>
  )
}

export default DepositOnlineMoneyGateRequisites;